/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SettingsTokensRouteImport } from './routes/settings.tokens'
import { Route as OrgsNewRouteImport } from './routes/orgs.new'
import { Route as OrgMembersRouteImport } from './routes/org.members'
import { Route as OrgInvitationsRouteImport } from './routes/org.invitations'
import { Route as InvitationsTokenRouteImport } from './routes/invitations.$token'
import { Route as FilesIdentifierRouteImport } from './routes/files.$identifier'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsTokensRoute = SettingsTokensRouteImport.update({
  id: '/settings/tokens',
  path: '/settings/tokens',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgsNewRoute = OrgsNewRouteImport.update({
  id: '/orgs/new',
  path: '/orgs/new',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgMembersRoute = OrgMembersRouteImport.update({
  id: '/org/members',
  path: '/org/members',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgInvitationsRoute = OrgInvitationsRouteImport.update({
  id: '/org/invitations',
  path: '/org/invitations',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationsTokenRoute = InvitationsTokenRouteImport.update({
  id: '/invitations/$token',
  path: '/invitations/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const FilesIdentifierRoute = FilesIdentifierRouteImport.update({
  id: '/files/$identifier',
  path: '/files/$identifier',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/files/$identifier': typeof FilesIdentifierRoute
  '/invitations/$token': typeof InvitationsTokenRoute
  '/org/invitations': typeof OrgInvitationsRoute
  '/org/members': typeof OrgMembersRoute
  '/orgs/new': typeof OrgsNewRoute
  '/settings/tokens': typeof SettingsTokensRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/files/$identifier': typeof FilesIdentifierRoute
  '/invitations/$token': typeof InvitationsTokenRoute
  '/org/invitations': typeof OrgInvitationsRoute
  '/org/members': typeof OrgMembersRoute
  '/orgs/new': typeof OrgsNewRoute
  '/settings/tokens': typeof SettingsTokensRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/files/$identifier': typeof FilesIdentifierRoute
  '/invitations/$token': typeof InvitationsTokenRoute
  '/org/invitations': typeof OrgInvitationsRoute
  '/org/members': typeof OrgMembersRoute
  '/orgs/new': typeof OrgsNewRoute
  '/settings/tokens': typeof SettingsTokensRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/signup'
    | '/files/$identifier'
    | '/invitations/$token'
    | '/org/invitations'
    | '/org/members'
    | '/orgs/new'
    | '/settings/tokens'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/signup'
    | '/files/$identifier'
    | '/invitations/$token'
    | '/org/invitations'
    | '/org/members'
    | '/orgs/new'
    | '/settings/tokens'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/signup'
    | '/files/$identifier'
    | '/invitations/$token'
    | '/org/invitations'
    | '/org/members'
    | '/orgs/new'
    | '/settings/tokens'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  SignupRoute: typeof SignupRoute
  FilesIdentifierRoute: typeof FilesIdentifierRoute
  InvitationsTokenRoute: typeof InvitationsTokenRoute
  OrgInvitationsRoute: typeof OrgInvitationsRoute
  OrgMembersRoute: typeof OrgMembersRoute
  OrgsNewRoute: typeof OrgsNewRoute
  SettingsTokensRoute: typeof SettingsTokensRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/tokens': {
      id: '/settings/tokens'
      path: '/settings/tokens'
      fullPath: '/settings/tokens'
      preLoaderRoute: typeof SettingsTokensRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orgs/new': {
      id: '/orgs/new'
      path: '/orgs/new'
      fullPath: '/orgs/new'
      preLoaderRoute: typeof OrgsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/org/members': {
      id: '/org/members'
      path: '/org/members'
      fullPath: '/org/members'
      preLoaderRoute: typeof OrgMembersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/org/invitations': {
      id: '/org/invitations'
      path: '/org/invitations'
      fullPath: '/org/invitations'
      preLoaderRoute: typeof OrgInvitationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitations/$token': {
      id: '/invitations/$token'
      path: '/invitations/$token'
      fullPath: '/invitations/$token'
      preLoaderRoute: typeof InvitationsTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/files/$identifier': {
      id: '/files/$identifier'
      path: '/files/$identifier'
      fullPath: '/files/$identifier'
      preLoaderRoute: typeof FilesIdentifierRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
  FilesIdentifierRoute: FilesIdentifierRoute,
  InvitationsTokenRoute: InvitationsTokenRoute,
  OrgInvitationsRoute: OrgInvitationsRoute,
  OrgMembersRoute: OrgMembersRoute,
  OrgsNewRoute: OrgsNewRoute,
  SettingsTokensRoute: SettingsTokensRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
